import { useEffect, useState } from 'react'
import { getRandomColor } from './colors'
export const useRandomLinkColors = () => {
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    // Check if we're on mobile based on screen width
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768) // 768px is the md breakpoint in Tailwind
    }
    // Check initially
    checkMobile()
    // Add event listener for window resize
    window.addEventListener('resize', checkMobile)
    // Clean up
    return () => window.removeEventListener('resize', checkMobile)
  }, [])
  // Apply random colors to all links on both mobile and desktop
  useEffect(() => {
    // Use a small delay to ensure all links are in the DOM
    const applyColors = () => {
      const links = document.querySelectorAll('a')
      const buttons = document.querySelectorAll('button')
      // Apply to links
      links.forEach((link) => {
        if (!link.dataset.colorApplied) {
          link.style.color = getRandomColor()
          link.dataset.colorApplied = 'true'
          // For desktop, we need to add the hover behavior manually
          if (!isMobile) {
            link.addEventListener('mouseenter', () => {
              link.style.color = getRandomColor()
            })
            link.addEventListener('mouseleave', () => {
              // Generate a new random color when mouse leaves
              link.style.color = getRandomColor()
            })
          }
        }
      })
      // Apply to buttons with data-color-applied="false"
      buttons.forEach((button) => {
        if (button.dataset.colorApplied === 'false') {
          button.style.color = getRandomColor()
          button.dataset.colorApplied = 'true'
          // For desktop, we need to add the hover behavior manually
          if (!isMobile) {
            button.addEventListener('mouseenter', () => {
              button.style.color = getRandomColor()
            })
            button.addEventListener('mouseleave', () => {
              // Generate a new random color when mouse leaves
              button.style.color = getRandomColor()
            })
          }
        }
      })
    }
    // Apply colors immediately
    applyColors()
    // And also after a short delay to catch any dynamically added elements
    const timeoutId = setTimeout(applyColors, 100)
    return () => clearTimeout(timeoutId)
  }, [isMobile])
  // Set document title for all pages to ensure it stays consistent
  useEffect(() => {
    document.title = 'Madeleine Morlet'
  }, [])
  return isMobile
}
